import { Component, ViewContainerRef } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

import { CreationService } from '../../../services';
import { FilterResponseModel } from '../../../models';
import { CreationFilterModel } from '../../../models/creation';
import { AppUtils } from '../../../helpers';

@Component({
    selector: 'creation-search-result',
    templateUrl: './creation.search.result.component.html'
})

export class CreationSearchResultComponent {
    @BlockUI('container-search-result') blockUI: NgBlockUI;

    filterModel: CreationFilterModel = new CreationFilterModel();

    isComponentInitiated = false;
    filterResponse: FilterResponseModel = new FilterResponseModel();
    selectedCreation: FilterResponseModel = new FilterResponseModel();
    pageCount: number;
    totalRecords: number;
    pageSize = 16;
    modalReference: any;

    constructor(private vcr: ViewContainerRef,
        private router: Router,
        private route: ActivatedRoute,
        private modalService: NgbModal,
        private toastr: ToastsManager,
        private appUtils: AppUtils,
        private creationService: CreationService) {

        this.toastr.setRootViewContainerRef(this.vcr);

        this.route.queryParams.subscribe(params => {
            this.filterModel.curatedOnly = (params['co'] === '1');
            if (params['q']) {
                this.filterModel.filterKey = params['q'];
            } else {
                this.filterModel.filterKey = null;
            }
        });

        router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.filterCreations(1);
            }
        });
    }

    filterCreations(page: number) {
        this.blockUI.start();
        this.filterModel.pageNumber = page;
        this.filterModel.perPage = this.pageSize;
        this.pageCount = page;
        this.creationService.filter(this.filterModel)
            .subscribe(
                data => {
                    this.blockUI.stop();
                    this.isComponentInitiated = true;
                    Object.assign(this.filterResponse, data);
                },
                error => {
                    this.blockUI.stop();
                    this.isComponentInitiated = true;
                    this.appUtils.ProcessErrorResponse(this.toastr, error);
                }
            );
    }

    vote(contestSubmission: any) {
        if (!this.appUtils.isUserAuthenticated()) {
            this.router.navigate(['/account/login']);
            setTimeout(() => {
                this.toastr.info('Please sign in to continue');
            }, 100);
            return;
        }
        if (contestSubmission.isVoted) {
            this.downVote(contestSubmission);
        } else {
            this.upVote(contestSubmission);
        }
    }

    upVote(contestSubmission: any) {
        this.blockUI.start();
        this.creationService.upVote(contestSubmission.id)
            .subscribe(
                () => {
                    this.blockUI.stop();
                    contestSubmission.isVoted = true;
                    contestSubmission.totalVotes += 1;
                },
                error => {
                    this.blockUI.stop();
                    this.appUtils.ProcessErrorResponse(this.toastr, error);
                });
    }

    downVote(contestSubmission: any) {
        this.blockUI.start();
        this.creationService.downVote(contestSubmission.id)
            .subscribe(
                () => {
                    this.blockUI.stop();
                    contestSubmission.isVoted = false;
                    contestSubmission.totalVotes -= 1;
                },
                error => {
                    this.blockUI.stop();
                    this.appUtils.ProcessErrorResponse(this.toastr, error);
                });
    }


    open(content: any, creation: FilterResponseModel) {
        this.selectedCreation = creation;
        this.modalReference = this.modalService.open(content);
    }

    close() {
        this.modalReference.close();
    }
}



// WEBPACK FOOTER //
// ./src/components/creation/search-result/creation.search.result.component.ts